import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["parallaxItem", "heroSection", "mapItem"]

  connect() {
    this.setupParallaxItems()
    this.bindEvents()
  }

  setupParallaxItems() {
    this.parallaxItemTargets.forEach(item => {
      const style = item.getAttribute('style') || ''
      const rotateMatch = style.match(/rotate\(([^)]+)\)/)
      if (rotateMatch && rotateMatch[1]) {
        item.dataset.rotateAngle = rotateMatch[1]
      } else {
        item.dataset.rotateAngle = '0deg'
      }
    })
  }

  bindEvents() {
    this.mouseMoveHandler = this.handleMouseMove.bind(this)
    window.addEventListener('mousemove', this.mouseMoveHandler, { passive: true })
  }

  disconnect() {
    window.removeEventListener('mousemove', this.mouseMoveHandler)
  }

  handleMouseMove(e) {
    if (!this.hasHeroSectionTarget) return

    const rect = this.heroSectionTarget.getBoundingClientRect()

    if (rect.bottom < -200) return

    const sectionCenterX = rect.left + rect.width / 2
    const sectionCenterY = rect.top + rect.height / 2
    const mouseX = e.clientX
    const mouseY = e.clientY
    const distanceX = mouseX - sectionCenterX
    const distanceY = mouseY - sectionCenterY

    // Parallax effect for property cards
    this.parallaxItemTargets.forEach(item => {
      const moveX = distanceX * -0.01
      const moveY = distanceY * -0.01
      item.style.transform = `translate(${moveX}px, ${moveY}px) rotate(${item.dataset.rotateAngle})`
    })

    // Parallax effect for map (more subtle)
    if (this.hasMapItemTarget) {
      const mapMoveX = distanceX * -0.005
      const mapMoveY = distanceY * -0.005
      this.mapItemTarget.style.transform = `translate(${mapMoveX}px, ${mapMoveY}px)`
    }
  }
}
